module.exports = __webpack_public_path__ + "static/media/file.9df9557b.jpg";